module.exports = __webpack_public_path__ + "img/Twitter_Logo_WhiteOnImage.9995b2b8.svg";